import Api from "../api";
let uri = "/api/ed/notificacion";
let readUri = "/api/ed/notificaciones";

export const getNotificaciones = () => {
  return Api.getInstance()
    .executeGetQuery(`${readUri}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const createNotificacion = (data) => {
  return Api.getInstance()
    .executeQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const editNotificacion = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getNotificacionesUsuario = (idUsuario) => {
  return Api.getInstance()
    .executeGetQuery(`${readUri}/usuario/${idUsuario}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const updateNotificacionesUsuario = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(`${readUri}/usuario/actualizar`, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};
